export const DEFAULT_FONTS = [
    'Companion-sans',
    'Companion-symbols1',
    'Companion-symbols2',
    'Companion-symbols3',
    'Companion-symbols4',
    'Companion-symbols5',
    'Companion-symbols6',
    'Companion-gurmukhi',
    'Companion-simplified-chinese',
    'Companion-korean',
    'Companion-emoji',
];
export const DEFAULT_FONTS_STR = DEFAULT_FONTS.join(',');
//# sourceMappingURL=Fonts.js.map